import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {AddressReducerType, ISearchAddressParams} from "./Types";
import Address from "../../Models/Address";

const initialState: AddressReducerType = {
  addresses: [],
}

const AddressSlice = createSlice({
  name: "Address",
  initialState,
  reducers: {
    getAddresses(state, { payload }: PayloadAction<ISearchAddressParams>) {},
    setAddresses(state: any, { payload }: PayloadAction<Address[]>) {
      state.addresses = payload
    },
    deleteAddress(state, { payload }: PayloadAction<Address>) {},
    saveAddress(state, { payload }: PayloadAction<Address>) {}
  }
});

export const AddressActions = AddressSlice.actions;

export default AddressSlice.reducer
